import styled from 'styled-components/';
import AppCSS from '../../../utils/styled';

export const Components = {
  Container: styled.div<{ isFullHeight?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 8px;
    width: 100%;
  `,
  TextAreaContainer: styled.div`
    width: 100%;
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.radiuses.small};
    background-color: ${AppCSS.colors.white};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  `,
  TextArea: styled.textarea`
    resize: none;
    flex: 1;
    background-color: transparent;
    padding: 12px;
    ${AppCSS.radiuses.small};
    border: none;
    ${AppCSS.fonts.label12Medium};
    color: ${AppCSS.colors.black};
    -webkit-appearance: none;
    &:focus-visible {
      -webkit-appearance: none;
      border: none;
      outline: none;
    }
    &:focus {
      -webkit-appearance: none;
      border: none;
      outline: none;
    }
    &::placeholder {
      color: ${AppCSS.colors.greys.prettyDark};
    }
  `,
  ErrorMessage: styled.span`
    ${AppCSS.fonts.label10Regular};
    color: ${AppCSS.colors.red};
  `,
};
